'use client'

import { cn } from '@/lib/utils'
import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'
import { unstable_ViewTransition as ViewTransition } from 'react'

export const PageContainer = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname()
  const fullscreenPages = ['/models/leaderboard', '/voice-models/leaderboard']
  const isFullscreen = fullscreenPages.includes(pathname)
  return (
    <div
      className={cn(
        isFullscreen
          ? 'fixed inset-x-0 bottom-0 top-[51px] overflow-auto'
          : 'mx-auto grid max-w-2xl sm:max-w-3xl gap-12 border-none pt-24 pb-16 sm:border-x px-4 sm:px-8'
      )}
    >
      <ViewTransition>{children}</ViewTransition>
    </div>
  )
}

export default PageContainer
